import APIClient from '@/shared/http/clients/api'

const resourceName = 'Ferramentas'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetFerramentasFiltros = (apr, revisao, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetFerramentas/${apr}/${revisao}`, data, config)

const AprActivitiesRepository = {
  GetFerramentasFiltros
}

export default AprActivitiesRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/tools.js